import { SPACE, WEIGHT } from '$gstyles';
import { IonPage } from '@ionic/react';
import styled from 'styled-components';

export const IonPageWrapper = styled(IonPage)`
  .superadmin-card {
    background: var(--ion-card-background);
    border-radius: 8px;
    padding: ${SPACE.MEDIUM};
    margin-bottom: ${SPACE.MEDIUM};
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);

    .superadmin-header {
      display: flex;
      justify-content: space-between;
      align-items: center;
      margin-bottom: ${SPACE.SMALL};

      .superadmin-name {
        font-weight: ${WEIGHT.SEMI_BOLD};
        font-size: 1.1em;
      }

      .access-badge {
        padding: 4px 12px;
        border-radius: 12px;
        font-size: 0.85em;
        font-weight: ${WEIGHT.NORMAL};

        &.all-access {
          background: #e8f5e9;
          color: #2e7d32;
        }

        &.restricted {
          background: #fff3e0;
          color: #ef6c00;
        }
      }
    }

    .superadmin-email {
      color: var(--ion-color-medium);
      font-size: 0.9em;
      margin-bottom: ${SPACE.SMALL};
    }

    .factory-chips {
      display: flex;
      flex-wrap: wrap;
      gap: ${SPACE.SMALL};
      margin-top: ${SPACE.SMALL};

      .factory-chip {
        background: var(--ion-color-light);
        padding: 4px 10px;
        border-radius: 16px;
        font-size: 0.85em;
      }
    }
  }

  .modal-content {
    padding: ${SPACE.LARGE};

    .factory-list {
      max-height: 400px;
      overflow-y: auto;

      .factory-item {
        display: flex;
        align-items: center;
        padding: ${SPACE.SMALL} 0;
        border-bottom: 1px solid var(--ion-border-color);

        &:last-child {
          border-bottom: none;
        }

        label {
          margin-left: ${SPACE.SMALL};
          cursor: pointer;
        }
      }
    }
  }

  .empty-state {
    text-align: center;
    padding: ${SPACE.XXLARGE};
    color: var(--ion-color-medium);
  }
`;
